import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet'
import { File, PlusCircle, Edit, XCircle, ChevronLeft, ChevronRight, RefreshCw } from 'react-feather'
import { Link, useLocation  } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import ReactPaginate from 'react-paginate'

// variables
import { SITENAME } from '../../configuration.js';

// components
import PageHead from '../../components/PageHead';
import Loading from '../../components/Loading';
import Table from '../../components/Table';
import TextSearchField from '../../components/TextSearchField';

// controllers
import _actions from '../../controllers/redux/actions'
import { _apiGETmulti, _apiDELETE, _apiGETone } from '../../controllers/Api';


export default function TemplateDocuments(props){

  const dispatch = useDispatch();
  const auth = dispatch(_actions.auth.authStatus());
  const location = useLocation()

  const fields = {
    limit: 15,
    offset: 0,
    orderBy: 'dateCreated|desc',
    search: '',
    clientId: auth.response.role >= 10 ? auth.response.clientId : null
  }

  const [ reload, setReload ] = React.useState(1);

  const [ loading, setLoading ] = React.useState(true);
  const [ request, setRequest ] = React.useState(location.state ? location.state.request : fields)
  const [ requestAction, setRequestAction ] = React.useState(location.state ? location.state.request : fields)
  const [ total, setTotal ] = React.useState(0)
  const [ data, setData ] = React.useState([])


  //
  //
  const _paginateAction = (e) => {
    const offset = e.selected === 0 ? 0 : (e.selected*fields.limit)
    _updateField('offset',offset)
  }



  //
  //
  const _updateField = (field, data) => {
    setRequest({...request, [field]:data});
  }


  //
  //
  const _delete = async (id) => {

    if (!window.confirm(`Are you sure you want to delete?`)){
      return;
    }else{

      let route = '/main-documents/'
      if(auth.response.role>2){
        route = '/documents/'
      }

      const del = await _apiDELETE(route+id);
      if(del.error){
        toast.error(del.error.message);
      }else{
        toast.success(del.message);
        setReload(reload+1)
      }

    }

  }


  //
  //
  const _sync1 = async () => {

    setLoading(true)

    const sync = await _apiGETone('/helpers/sync-missing-documents/'+auth.response.clientId);
    if(sync.error){
      toast.error(sync.error.message);
      setLoading(false)
    }else{
      toast.success(sync.message);
      setReload(reload+1)
    }

  }


  //
  //
  const _sync2 = async () => {

    setLoading(true)

    const sync = await _apiGETone('/helpers/sync-existing-documents/'+auth.response.clientId);
    if(sync.error){
      toast.error(sync.error.message);
      setLoading(false)
    }else{
      toast.success(sync.message);
      setReload(reload+1)
    }

  }


  //
  //
  React.useEffect(() => {
    const timeoutId = setTimeout(() => request !== '' ? setRequestAction(request) : null, 500 );
    return () => clearTimeout(timeoutId);
  }, [request]);


  //
  //
  React.useEffect(()=>{

    setLoading(true)

    let route = '/main-documents/query'
    if(auth.response.role>2){
      route = '/documents/query'
    }

    const getData = async () =>{
      const res = await _apiGETmulti(route, requestAction)
      if(res.error){

      }else{
        setTotal(res.total)
        setData(res.data)
      }
      setLoading(false)
    }
    getData()

    return (() => [getData])
  },[requestAction, reload, auth.response.role])


  //
  //
  const _options = (data, index) => {

    return (
      <div className="d-flex justify-content-end align-items-center">
        {auth.response.role <= 11 && <Link to={{pathname:'/templates/documents/'+data._id, state:{request:request, pathname:location.pathname}}} className="iconButton"><Edit size={20}/></Link>}
        {auth.response.role <= 2 && <button className="iconButton" onClick={()=>_delete(data._id)}><XCircle size={20}/></button>}
      </div>
    )

  }



  //
  //
  return (
    <Fragment>
      <Helmet>
        <title>Templates / Documents | { SITENAME }</title>
      </Helmet>

      <PageHead
        title="Templates / Documents"
        icon={<File size={52}/>}
      >
        <TextSearchField
          type="text"
          name="search"
          value={request.search}
          onChange={(e)=>_updateField('search',e)}
          placeholder="search..."
        />
        {auth.response.role <= 2 && <Link to={{pathname:'/templates/documents/new', state:{request:request, pathname:location.pathname}}} className="button accent ml-1"><PlusCircle/>Add new</Link>}
        <div className='ml-3'>
        {/* {auth.response.role >= 10 && <button type="button" className="link ml-1" onClick={()=>_sync2()}><RefreshCw/>Sync existing documents</button>} */}
        {auth.response.role >= 10 && <button type="button" className="link ml-1" onClick={()=>_sync1()}><RefreshCw/>Sync missing documents</button>}
        </div>
      </PageHead>

      <div className="relative w-100">
        {total===0 ?
          <div className="text-center py-4">{loading ? 'loading...' : 'No data vailable.'}</div>
        :
          <>
          <Table
            action={_updateField}
            perPage={request.limit}
            sortBy={request.orderBy}
            head={
              [
                {name:'Title', width:'auto', sortable:true, key:'title'},
                {name:'Key', width:'25%', sortable:true, key:'key'},
                {name:'Created on', width:'15%', sortable:true, key:'dateCreated', type:'date'},
                {name:'Updated on', width:'15%', sortable:true, key:'dateUpdated', type:'date'},
                {name:'Options', width:'10%', sortable:false, key:'_', type:'function', func:_options}
              ]
            }
            body={data}
            total={total}
          />
          <ReactPaginate
            previousLabel={<ChevronLeft/>}
            nextLabel={<ChevronRight/>}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={Math.ceil(total/fields.limit)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={_paginateAction}
            containerClassName={'pagination'}
            activeClassName={'active'}
          />
          </>
        }
        <Loading status={loading}/>
      </div>

    </Fragment>
  );

}
